import { useState } from "react";

import FoldableSection from "components/UI/FoldableSection/FoldableSection";
import Icon from "components/UI/IconSVG/Icon";

import "./FooterPlate.scss";

export default function FooterPlate({ title, subtitle, items, note, isMobile }) {
  const [expanded, setExpanded] = useState(false);
  const isContacts = title === "Контакты";

  const renderHeader = () => (
    <div className="footer-plate__header" onClick={isMobile ? () => setExpanded(!expanded) : undefined}>
      <p className="footer-plate__header-title">{title}</p>
      {isMobile 
        ? <Icon className={`footer-plate__header-icon ${expanded ? 'expanded' : ''}`} sprite="projects" name="accordion" />
        : subtitle && <p className="footer-plate__header-subtitle">{subtitle}</p>
      }
    </div>
  );

  const renderContent = () => (
    <div className="footer-plate__content">
      {isMobile && subtitle && <p className="footer-plate__header-subtitle">{subtitle}</p>}
      <div className="footer-plate__column">
        {items.map((item, index) => (
          <div className="footer-plate__column-container" key={index}>
            {item.title && <p className="footer-plate__column-title">{item.title}</p>}
            {item.to
              ? <a className={`footer-plate__column-link ${isContacts ? 'no-underline' : ''}`} href={item.to} target={item.target || "_self"} onClick={item.onClick}>{item.text}</a>
              : <p className="footer-plate__column-text">{item.text}</p>}
          </div>
        ))}
      </div>
      {note && note}
    </div>
  );

  return (
    <div className="footer-plate">
      {isMobile 
        ? <FoldableSection className={`footer-plate__foldable ${expanded ? 'expanded' : ''}`} expanded={expanded}>
            {renderHeader()}
            {renderContent()}
          </FoldableSection>
        : <>
            {renderHeader()}
            {renderContent()}
          </>
      }
    </div>
  );
}